import { rentalAgreementHistories } from '@homevest/utils'

const { RENTAL_AGREEMENT_HISTORY_TYPES } = rentalAgreementHistories

export const excludeHoldoverAgreementHistories = <T extends { type?: string | null }>(
  histories: T[]
) => histories.filter(({ type }) => type !== RENTAL_AGREEMENT_HISTORY_TYPES.HOLDOVER)

export const getLatestNonHoldoverAgreementHistory = <
  T extends { ends_at: string; type?: string | null }
>(
  histories: T[]
) =>
  [...excludeHoldoverAgreementHistories(histories)].sort(
    (left, right) => new Date(right.ends_at).getTime() - new Date(left.ends_at).getTime()
  )[0]
